var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34851 12.1138H23.3485",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8485 18.1138V20.3638C21.8485 20.5627 21.7695 20.7534 21.6288 20.8941C21.4882 21.0348 21.2974 21.1138 21.0985 21.1138H18.8485C18.6496 21.1138 18.4588 21.0348 18.3182 20.8941C18.1775 20.7534 18.0985 20.5627 18.0985 20.3638V18.1138",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59851 18.1138V20.3638C7.59851 20.5627 7.51949 20.7534 7.37884 20.8941C7.23819 21.0348 7.04742 21.1138 6.84851 21.1138H4.59851C4.3996 21.1138 4.20883 21.0348 4.06818 20.8941C3.92753 20.7534 3.84851 20.5627 3.84851 20.3638V18.1138",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84851 15.1138H8.34851",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3485 15.1138H18.8485",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8485 12.1138L19.0454 5.81377C18.9872 5.68049 18.8916 5.56699 18.7701 5.4871C18.6485 5.4072 18.5064 5.36435 18.361 5.36377H7.33601C7.19059 5.36435 7.04848 5.4072 6.92697 5.4871C6.80546 5.56699 6.7098 5.68049 6.65164 5.81377L3.84851 12.1138V18.1138H21.8485V12.1138Z",
    stroke: "#6D737A",
    strokeWidth: 1.60606,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.4a43a9220107511a6a7c52e1a8c535df.svg";
export { ForwardRef as ReactComponent };